export type AccountsReceivableInstallment = {
  id: string;
  customer: {
    id: string;
    commercialName: string;
    companyName?: string;
  };
  brandCommercialName?: string;
  invoiceId: string;
  brandId: string;
  receivableCode: string;
  integrationCode: string;
  documentType: AccountsReceivableDocumentTypeEnum;
  installmentNumber: number;
  dueDate: string;
  status: InstallmentStatusEnum;
  value: number;
  paidValue: number;
  netValue: number;
  grossValue: number;
  createdAt: string;
  updatedAt: string;
  paidAt?: string;
  discount?: number;
  chargesValue?: number;
  pixQrCode?: string;
  digitableLine?: string;
  pdfUrl?: string;
  installmentsAmount?: number;
};

export enum InstallmentStatusEnum {
  PAID = 'PAID',
  PENDING = 'PENDING',
  OVERDUE = 'OVERDUE',
}

export enum AccountsReceivableDocumentTypeEnum {
  INVOICE = 'INVOICE',
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
  CASH = 'CASH',
  CHECK = 'CHECK',
  PIX = 'PIX',
}

export type AccountsReceivableInstallmentTotalItem = {
  count: number;
  grossTotal: number;
  discountTotal: number;
  chargesTotal: number;
  netTotal: number;
  paidTotal: number;
  unpaidTotal: number;
};

export type AccountsReceivableInstallmentTotals = Record<
  'paid' | 'pending' | 'overdue' | 'all',
  AccountsReceivableInstallmentTotalItem
>;

export enum InstallmentSyncChangedField {
  PAID_VALUE = 'PAID_VALUE',
  VALUE = 'VALUE',
  STATUS = 'STATUS',
  GROSS_VALUE = 'GROSS_VALUE',
  NET_VALUE = 'NET_VALUE',
  DISCOUNT = 'DISCOUNT',
  CHARGES_VALUE = 'CHARGES_VALUE',
  PAYMENT_DATE = 'PAYMENT_DATE',
}

export enum InstallmentSyncStatusEnum {
  OK = 'OK',
  ERROR = 'ERROR',
}

export type AccountsReceivableInstallmentSyncHistoryItem = {
  id: string;
  status: InstallmentSyncStatusEnum;
  createdAt: string;
  changedField: {
    [InstallmentSyncChangedField.PAID_VALUE]?: number;
    [InstallmentSyncChangedField.VALUE]?: number;
    [InstallmentSyncChangedField.GROSS_VALUE]?: number;
    [InstallmentSyncChangedField.NET_VALUE]?: number;
    [InstallmentSyncChangedField.DISCOUNT]?: number;
    [InstallmentSyncChangedField.CHARGES_VALUE]?: number;
    [InstallmentSyncChangedField.STATUS]?: InstallmentStatusEnum;
    [InstallmentSyncChangedField.PAYMENT_DATE]?: string;
  };
};
